import dayjs from "dayjs"
import get from "lodash.get"
import { getClientContact } from "@/utils/"
import { getOriginalPrice, getOptionalBenefits } from "./utils/"

export default (ctx, payload) => {
	const header = schema(ctx, payload).map(item => item.label)
	const body = payload.map(data => schema(ctx).map(y => [y.data(data)]))
	const workSheetData = [header, ...body]
	const workSheetColumns = schema(ctx).map(item => {
		return { wpx: 150 }
	})
	return { workSheetData, workSheetColumns }
}

const schema = ctx => [
	{ label: "Policy Number", data: item => item.issuerNumber },
	{ label: "Client", data: item => get(item, "holder.name") },
	{ label: "Client Type", data: item => get(item, "holder.__typename") },
	{
		label: "Email",
		data: item => getClientContact("email", get(item, "holder.contacts"))
	},
	{
		label: "Insurance Type",
		data: item => get(item, "product.productId.type")
	},
	{
		label: "Product",
		data: item =>
			get(item, "product.name") + ` (${get(item, "product.productId.version")})`
	},
	{ label: "Insurer", data: item => get(item, "product.insurer.name") },
	{
		label: "Optional benefits",
		data: item => getOptionalBenefits(item)
	},
	{
		label: "Premium before discounts",
		data: item => getOriginalPrice(item)
	},
	{
		label: "Premium after discounts",
		data: item => get(item, "pricing.amount")
	},
	// {
	// 	label: "Applied discounts",
	// 	data: item => getDiscountsRatioTotal(item) * 100
	// },
	{ label: "Currency", data: item => get(item, "pricing.currencyCode") },
	{ label: "Status", data: item => (item.status ? ctx.$t(item.status) : null) },
	{ label: "Referral", data: item => get(item, "referrer.name") },
	{ label: "Source", data: item => item.source },
	{
		label: "Start Date",
		data: item =>
			item.startDate
				? dayjs(item.startDate).format(ctx.settings.dateFormat)
				: null
	},
	{
		label: "End Date",
		data: item =>
			item.endDate ? dayjs(item.endDate).format(ctx.settings.dateFormat) : null
	},
	{
		label: "Issue Date",
		data: item =>
			item.issueDate
				? dayjs(item.issueDate).format(ctx.settings.dateFormat)
				: null
	},
	{
		label: "Created",
		data: item =>
			item.createdAt
				? dayjs(item.createdAt).format(ctx.settings.dateTimeFormat)
				: null
	},
	{
		label: "Commission for",
		data: item =>
			item.commissionSummary && item.commissionSummary.entity
				? item.commissionSummary.entity.name
				: "Company"
	},
	{
		label: "Commission as % of Premium",
		data: item =>
			item.commissionSummary && item.commissionSummary.ratio
				? item.commissionSummary.ratio * 100
				: ""
	},
	{
		label: "Commission Amount",
		data: item => get(item, "commissionSummary.amount")
	},
	{
		label: "Commission Currency",
		data: item => get(item, "commissionSummary.currencyCode")
	}
]
